/** Letters, marks, digits and apostrophes: what a word piece is made of. A hyphen ends a piece. */
const PIECE_CHAR = String.raw`[\p{L}\p{M}\p{N}'’]`
const LEADING_PIECE = new RegExp(`^${PIECE_CHAR}+`, 'u')
const TRAILING_PIECE = new RegExp(`${PIECE_CHAR}+$`, 'u')

/** The word piece that begins `text`, or `''` when it begins with a space, a hyphen or punctuation. */
export function leadingWordPiece(text: string): string {
  return LEADING_PIECE.exec(text)?.[0] ?? ''
}

/** The word piece that ends `text`, or `''` when it ends with a space, a hyphen or punctuation. */
export function trailingWordPiece(text: string): string {
  return TRAILING_PIECE.exec(text)?.[0] ?? ''
}
